import httpClient from '@/libs/http-client'

export function signIn (params) {
  const url = '/user/login'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function signUp (params) {
  const url = '/samsung/user/signup'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function refreshToken (token) {
  const url = '/auth/refresh'
  const config = {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }

  return httpClient.post(url, {}, config).then(response => {
    return response.data.result
  })
}

export function getUserInfo () {
  const url = '/samsung/user/get_info'

  return httpClient.post(url).then(response => {
    let result = response.data.result
    if (['admin', 'samsung_gmc'].includes(result.userId)) {
      result.isGmc = true
    }
    if (result.originalSiteCodeList) {
      result.originalSiteCodeList.sort()
    }
    if (result.etcSiteCodeList) {
      result.etcSiteCodeList.sort()
    }
    if (result.siteCodeList) {
      result.siteCodeList.sort()
    }
    if (result.remainPv) {
      result.creditEmpty = false
    }
    return result
  })
}

export function findPassword (params) {
  const url = '/samsung/user/find_password'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function resetPassword (params) {
  const url = '/user/reset_password'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function checkDupId (params) {
  const url = '/samsung/user/check_dup_id'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function checkDupEmail (params) {
  const url = '/samsung/user/check_dup_email'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function modify (params) {
  const url = '/samsung/user/modify'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function getPvStatus (startDate, endDate) {
  const url = '/samsung/user/get_pv_status'

  return httpClient.post(url, { startDate, endDate }).then(response => {
    return response.data.result
  })
}

export function deactivateInfo () {
  const url = '/samsung/user/deactivate_info'

  return httpClient.get(url).then(response => {
    return response.data.result
  })
}

export function deactivate (params) {
  const url = '/samsung/user/deactivate'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function myInfoLogin (password) {
  const url = '/user/myinfo_login'

  return httpClient.post(url, { password }).then(response => {
    return response.data.result
  })
}

export function getClientIds () {
  const url = '/user/get_client_ids'

  return httpClient.get(url).then(response => {
    return response.data.result
  })
}

export function getClientAuth (id) {
  const url = `/user/get_client_auth?userId=${id}`

  return httpClient.get(url).then(response => {
    return response.data.result
  })
}

export function userList (params) {
  const url = '/samsung/user/list'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function userApprove (params) {
  const url = '/samsung/user/approve'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function userInfo (params) {
  const url = '/samsung/user/info'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function updateUserInfo (params) {
  const url = '/samsung/user/update'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}
